import styles from './InputForm.module.css';

export default function InputForm({ mode, title, type, name, value, onChange, placeholder, options, required = true, accept, marginBottom = '1.5rem' }) {
  if(mode === 'input') {
    return (
      <div className={styles.formGroup} style={{ marginBottom: marginBottom}}>
        <label htmlFor={name}>{title}</label>
        <input 
          type={type}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          className={styles.input}
          accept={accept}
          required={required}
        />
      </div>
    )
  }
  else if(mode === 'textarea') {
    return (
      <div className={styles.formGroup} style={{ marginBottom: marginBottom}}>
        <label htmlFor={name}>{title}</label>
        <textarea 
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={styles.textarea}
          required={required}
        />
      </div>
    )
  }
  else if(mode === 'select') {
    return (
      <div className={styles.formGroup} style={{ marginBottom: marginBottom }}>
        <label htmlFor={name}>{title}</label>
        <select 
          name={name}
          value={value}
          onChange={onChange}
          className={styles.select}
          required
        >
          {options.map((opt, index) => (
          <option key={index} value={opt.value} disabled={opt.value === ''} hidden={opt.value === ''}>
            {opt.name}
          </option>
        ))}
        </select>
      </div>
    )
  }
  else if (mode === 'checkbox') {
    return (
      <div className={styles.formGroup} style={{ marginBottom: marginBottom }}>
        <label>{title}</label>
        <div className={styles.checkboxGroup}>
          {options.map((opt, index) => (
            <label key={index} className={styles.checkboxItem}>
              <input
                type="checkbox"
                name={name}
                value={opt.value}
                checked={value.includes(opt.value)}
                onChange={(e) => {
                  let newValue = [...value];
                  if (e.target.checked) {
                    newValue.push(opt.value);
                  } else {
                    newValue = newValue.filter((item) => item !== opt.value);
                  }
                  onChange({ target: { name, value: newValue } });
                }}
              />
              {opt.name}
            </label>
          ))}
        </div>
      </div>
    );
  }
}
